export const UNASSIGNED_OPTION_ID = "<unassigned>"

/**
 * Convert an array of assignee IDs (and unassigned option) to an array of assignee filters
 * @param assigneeIds - The array of assignee IDs to convert
 * @returns The array of assignee filters
 * @example convertAssigneeIdsToFilters(["1", "2"]) // ["(member;1)", "(member;2)"]
 * @example convertAssigneeIdsToFilters([UNASSIGNED_OPTION_ID, "1", "2"]) // ["(unassigned)", "(member;1)", "(member;2)"]
 */
export function convertAssigneeIdsToFilters(assigneeIds: string[]) {
  return assigneeIds.map((id) => {
    if (isUnassignedOptionId(id)) {
      return "(unassigned)"
    }
    return `(member;${id})`
  })
}

/**
 * Create an unassigned option for use in dropdowns
 * @param t - The translation function
 * @returns The unassigned option
 */
export function createUnassignedOption(t: (string: string) => string) {
  return {
    label: t("Unassigned"),
    value: UNASSIGNED_OPTION_ID,
  }
}

/**
 * Check if an option id is the unassigned option
 * @param option - The option to check
 * @returns True if the option is the unassigned option, false otherwise
 * @example isUnassignedOptionId(UNASSIGNED_OPTION_ID) // true
 * @example isUnassignedOptionId("1") // false
 */
export function isUnassignedOptionId(option: string) {
  return option === UNASSIGNED_OPTION_ID
}
